import React from 'react';
import { Helmet } from 'react-helmet/es/Helmet';
import { useTranslation } from 'react-i18next';

export const LandingHeader = () => {
  const { t } = useTranslation();
  return (
    <Helmet>
      <title>{t('document_title')}</title>
    </Helmet>
  );
};

export const RefuelingHeader = () => {
  const { t } = useTranslation();
  return (
    <Helmet>
      <title>{t('document_title', { name: `- ${t('refueling.document_title')}` })}</title>
    </Helmet>
  );
};

export const ParkingHeader = () => {
  const { t } = useTranslation();
  return (
    <Helmet>
      <title>{t('document_title', { name: `- ${t('parking.document_title')}` })}</title>
    </Helmet>
  );
};

export const OnStreetParkingHeader = () => {
  const { t } = useTranslation();
  return (
    <Helmet>
      <title>{t('document_title', { name: `- ${t('on_street_parking.document_title')}` })}</title>
    </Helmet>
  );
};

export const AutoRepairHeader = () => {
  const { t } = useTranslation();
  return (
    <Helmet>
      <title>{t('document_title', { name: `- ${t('auto_repair.document_title')}` })}</title>
    </Helmet>
  );
};

export const AutoDetailingHeader = () => {
  const { t } = useTranslation();
  return (
    <Helmet>
      <title>{t('document_title', { name: `- ${t('auto_detailing.document_title')}` })}</title>
    </Helmet>
  );
};

export const PoisGasStationsHeader = () => {
  const { t } = useTranslation();
  return (
    <Helmet>
      <title>{t('document_title', { name: `- ${t('pois.gas_stations_document_title')}` })}</title>
    </Helmet>
  );
};
export const PoisParkinglotsHeader = () => {
  const { t } = useTranslation();
  return (
    <Helmet>
      <title>{t('document_title', { name: `- ${t('pois.parkinglots_document_title')}` })}</title>
    </Helmet>
  );
};

export const PoisCarBeautyHeader = () => {
  const { t } = useTranslation();
  return (
    <Helmet>
      <title>{t('document_title', { name: `- ${t('pois.car_beauty_document_title')}` })}</title>
    </Helmet>
  );
};

export const PoisAutoRepairsHeader = () => {
  const { t } = useTranslation();
  return (
    <Helmet>
      <title>{t('document_title', { name: `- ${t('pois.auto_repair_document_title')}` })}</title>
    </Helmet>
  );
};

export const PoisCarWashHeader = () => {
  const { t } = useTranslation();
  return (
    <Helmet>
      <title>{t('document_title', { name: `- ${t('pois.car_wash_document_title')}` })}</title>
    </Helmet>
  );
};

export const PromotionHeader = () => {
  const { t } = useTranslation();
  return (
    <Helmet>
      <title>{t('document_title', { name: `- ${t('promotions.document_title')}` })}</title>
    </Helmet>
  );
};
